import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { rootRoute } from './root'
import { RouteError } from '@lunary/ui-web/screen-state'

export const readingRoute = createRoute({
  path: 'reading',
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import('../features/reading/page'), 'ReadingPage'),
  errorComponent: RouteError,
})
